import { AxiosResponse, AxiosError } from "axios";
import { useMutation } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { getDeleteTestUrl } from "@src/config/baseUrls";

const useDeleteTestResults = (studyId: string, testId: string) => {
  const axios = useAxios();

  return useMutation<AxiosResponse<string>, AxiosError, string>(
    ["deleteTest", studyId, testId],
    () => axios.delete(getDeleteTestUrl(studyId, testId)),
  );
};

export default useDeleteTestResults;
